import { useCenterThresholdTheme } from "../useCenterThresholdTheme";
import { motion } from "framer-motion";

import AboutOurStory from "../components/aboutComponents/aboutOurStory";
import AboutTeamRoles from "../components/aboutComponents/aboutTeamRoles";
import eboardTemplate from "../components/aboutComponents/eboardTemplate";
import "../css/about.css"
// Eboard images
import Heidi from "../assets/Eboard/heidi_eboard.jpg";      // copres
import Peony from "../assets/Eboard/peony_eboard.jpg";      // copres
import Celine from "../assets/Eboard/celine_eboard.jpg";    // programming director
import Andrew from "../assets/Eboard/andrew_eboard.jpg";    // finance director
import Joseph from "../assets/Eboard/joseph_eboard.jpg";    // lead editor
import Emma from "../assets/Eboard/emma_eboard.jpg";        // multimedia director
import Lindsey from "../assets/Eboard/lindsey_eboard.jpg";  // creative director
import Nathan from "../assets/Eboard/nathan_eboard.jpg";    // PR director
import Eric from "../assets/Eboard/eric_eboard.jpg";        // web lead
// Intern images
import Michelle from "../assets/Eboard/michelle_eboard.jpg";    // finance intern
import Jaydon from "../assets/Eboard/jaydon_eboard.jpg";        // multimedia intern
import Makena from "../assets/Eboard/makena_eboard.jpg";        // literature intern
// Alumni images
import Jeen from "../assets/Eboard/jeen_eboard.jpg";        // alumni
import Riya from "../assets/Eboard/riya_eboard.jpg";        // alumni
import HeroHistorySection from "../components/aboutComponents/HeroHistorySection";

const eboard_pics = [Heidi, Peony, Celine, Andrew, Emma, Joseph, Nathan, Lindsey, Eric];
const alum_pics = [Jeen, Riya]; //, null, null, null, null, null, null, null, null];
const intern_pics = [Michelle, Jaydon, Makena];

const eboard_positions = ["Co-President", "Co-President", "Programming Director", "Finance Director", "Multimedia Director", "Lead Editor", "PR Director", "Creative Director", "Web Lead"];
const intern_positions = ["Finance Intern", "Multimedia Intern", "Literature Intern"];
const alum_positions = ["PR Director", "Lead Editor", "gonna be honest i forgor", "Cofounder", "President", "Finance Director", "Web Lead", "Programming Director", "Gonna be honest, forgot", "Cofounder"];

const eboard_names = ["Heidi Arromdee", "Peony Duong", "Celine Chen", "Andrew Kim", "Emma Smith", "Joseph Caluya", "Nathan Nguyen", "Lindsey Piano", "Eric Chen"]; 
const intern_names = ["Michelle", "Jaydon Vang", "Makena Parker"]
const alum_names = ["Jeen Lee", "Riya Valaulikar"];// , "Stephanie Tong", "Yi-Ann Li", "Audrey Xia", "Bryan Choi", "Ethan Zhang", "Mindy Dang", "Chris Kwon", "Ellen Chung"];

const ease = "easeOut";
const dur = 0.55;

const headlineVariants = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: dur, ease },
  },
};

function About() { 
    useCenterThresholdTheme({ line: 0.5 });

	return (
        <div className="about-page">
            <section
                data-theme-section
                data-bg="#0B1730"
                data-bg-top="#1b1d2a"
                data-bg-bottom="#0f111a"
                data-glow="rgba(184,56,38,0.25)"
                data-fg="#FFFFFF"
            >
                <HeroHistorySection 
                    title="ABOUT DAY" 
                    message="We strive to uplift communities through education, activism, and celebration"
                />
            </section>
            <section
                data-theme-section
                data-bg="#fff8e7ff"
                data-fg="#220b30ff"
            >
                <div className="py-3 mb-4 border-bottom">
                    <a 
                        href="/" className="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto text-dark text-decoration-none">
                    </a>
                    <div className="container">
                    <motion.header
                        className="hero-history__headline-wrapper"
                        variants={headlineVariants}
                        >                                
                    <h1 className="meet-the-team__title meet-the-team__title--spaced">Meet the Team</h1>
                    </motion.header>
                        {eboardTemplate(eboard_pics, eboard_positions, eboard_names)}

                        <div className="row">
                            <div>
                                <h2 className="about-subtitle">INTERNS</h2>
                            </div>
                        </div>
                        {eboardTemplate(intern_pics, intern_positions, intern_names)}

                        <div className="row">
                            <div>
                                <h2 className="about-subtitle">ALUMNI</h2>
                            </div>
                        </div>
                        {eboardTemplate(alum_pics, alum_positions, alum_names)}
                    </div>

                    <div className="py-4"></div>

                    {AboutOurStory()}

                    {AboutTeamRoles()}
                </div>
            </section>
        </div>
	);
}
export default About;